export default `
query customer {
  customer {
    is_b2b
  }
}
`;